import { render, staticRenderFns } from "./VFormItemNumberWithBar.vue?vue&type=template&id=7223a507&"
import script from "./VFormItemNumberWithBar.vue?vue&type=script&lang=js&"
export * from "./VFormItemNumberWithBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7223a507')) {
      api.createRecord('7223a507', component.options)
    } else {
      api.reload('7223a507', component.options)
    }
    module.hot.accept("./VFormItemNumberWithBar.vue?vue&type=template&id=7223a507&", function () {
      api.rerender('7223a507', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VFormItemNumberWithBar.vue"
export default component.exports